import {
  mapState,
  mapMutations
} from 'vuex'
import api from '../service/services.js'
import swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'
import moment from 'moment'

export default {
  name: 'new_bill',
  data () {
    return {
      screenHeight: window.innerHeight - 220,
      isLoading: false,
      bill_use: false,
      bill_number: '',
      bill_status: 0,
      bill_status_options: [],
      bill_order: 0,
      bill_order_options: [],
      flashdrive: 0,
      TotalAmount: 0,
      photograph_name: [], // ข้อมูลช่างภาพ
      guide_name: [], // ข้อมูลไกด์
      cash: 0,
      credit_card: 0,
      files: [],
      fd_name: '',
      email: [],
      discription: ''
    }
  },
  components: {
    Loading
  },
  computed: {
    ...mapState(['user', 'url', 'config', 'uploads']),
    ...mapMutations(['checkLogin', 'logout'])
  },
  methods: {
    check_bill () {
      this.isLoading = true
      if (this.bill_number) {
        var obj = {
          bill_number: this.bill_number
        }
        api.AXcheckbill(this.url, obj,
          result => {
            this.isLoading = false
            if (result.status === 1) {
              this.guide_name.push('')
              this.photograph_name.push('')
              this.bill_use = true
            } else {
              swal('warning', result.data, 'warning')
            }
          },
          error => {
            this.isLoading = false
            alert(JSON.stringify(error))
          }
        )
      } else {
        this.isLoading = false
        document.getElementById('billNumber').focus()
        swal('warning', 'Bill Number No Data!!')
      }
    },
    getmenu () {
      api.AXitems(
        this.url,
        result => {
          this.bill_order_options = []
          this.bill_order = result.data[0]
          result.data.forEach(val => {
            this.bill_order_options.push({
              value: val,
              text: val['item_name']
            })
          })
        },
        error => {
          alert(JSON.stringify(error))
        }
      )
    },
    addPhotograp () {
      this.photograph_name.push('')
    },
    deletePhotograp (index) {
      if (index === 0) {
        this.photograph_name = []
        this.addPhotograp()
      } else {
        this.photograph_name.splice(index, 1)
      }
    },
    addGuide () {
      this.guide_name.push('')
    },
    deleteGuide (index) {
      if (index === 0) {
        this.guide_name = []
        this.addGuide()
      } else {
        this.guide_name.splice(index, 1)
      }
    },
    addEmail () {
      this.email.push('')
    },
    deleteEmail (index) {
      this.email.splice(index, 1)
    },
    check_str (value) {
      return /^[ก-๙]+$/gi.test(value)
    },
    previewImage (event) {
      this.files = []
      let uploadedFiles = this.$refs.files.files
      let folder_name = ''
      for (var i = 0; i < uploadedFiles.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(uploadedFiles[i].name)) {
          this.files.push(uploadedFiles[i])
          folder_name = uploadedFiles[i]['webkitRelativePath']
        }
      }
      var fl = folder_name.split('/')
      this.fd_name = fl[0]
      if (this.check_str(this.fd_name) === false) {
        this.getImagePreviews()
      } else {
        alert('กรุณาเปลี่ยนชื่อโฟร์เดอร์  * ชื่อไม่ควรเป็นภาษาไทย *')
        this.files = []
        this.getImagePreviews()
        const input = this.$refs.files
        input.type = 'text'
        input.type = 'file'
      }
    },
    getImagePreviews () {
      for (let i = 0; i < this.files.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].name)) {
          let reader = new FileReader()
          reader.addEventListener(
            'load',
            function () {
              this.$refs['image' + i][0].src = reader.result
            }.bind(this),
            false
          )
          reader.readAsDataURL(this.files[i])
        }
      }
    },
    fm_date (str) {
      return moment(str).format('YYYY-MM-DD')
    },
    updateProgressBarValue (billId, prevent) {
      var load = Math.round((prevent.loaded * 100) / prevent.total)
      // this.uploads.forEach(up => {
      var index = this.uploads.map(function (e) {
        return e.id
      }).indexOf(billId)
      if (index < 0) {
        this.uploads.push({
          id: billId,
          status: load,
          total: prevent.total
        })
      } else {
        this.uploads[index].status = load
        this.uploads[index].total = prevent.total
        if (load === 100) {
          this.uploads.splice(index, 1)
        }
      }
      // })
      // console.log(billId + ' = ' + JSON.stringify(this.uploads))
    },
    upload () {
      if (this.bill_use === true) {
        if (this.files.length > 0) {
          var obj = {
            bill_number: this.bill_number,
            item_id: 0, // parseInt(this.bill_order.item_id),
            item_qty: 1,
            flashdrive: 0, // parseInt(this.flashdrive),
            guide_name: 0, // this.guide_name.length,
            photograph_name: 0, // this.photograph_name.length,
            bill_amount: 0, // parseInt(this.TotalAmount),
            cash_amount: 0, // parseInt(this.cash),
            credit_amount: 0, // parseInt(this.credit_card),
            bill_key: '',
            bill_date: '',
            bill_folder: this.fd_name,
            bill_status: 0,
            cnt_upload: 0,
            total_upload: 0,
            discription: '', // this.discription,
            status_upload: 0,
            user_id: 0,
            cloud_image: 1
          }
          this.isLoading = true
          api.AXgetDoc(this.url, obj,
            result => {
              var Emails = []
              this.email.forEach(val => {
                if (val !== '') {
                  Emails.push({
                    email: val
                  })
                }
              })
              var objEmail = {
                id: result.data[0].bill_id,
                data: Emails
              }
              if (Emails.length > 0) {
                api.AXaddemail(this.url, objEmail,
                  result => {
                    swal({
                      position: 'top-end',
                      type: 'success',
                      title: 'Add Email Success!!',
                      showConfirmButton: false,
                      timer: 1500
                    })
                    console.log(result)
                  },
                  error => {
                    alert(JSON.stringify(error))
                  }
                )
              }

              var date = this.fm_date(result.data[0].bill_date)
              let formData = new FormData()
              formData.append('bill_id', result.data[0].bill_id)
              formData.append('bill_key', result.data[0].bill_key)
              for (var i = 0; i < this.files.length; i++) {
                let file = this.files[i]
                formData.append('upload[' + i + ']', file)
              }
              formData.append('item_id', parseInt(this.bill_order.item_id))
              formData.append('item_qty', 1)
              formData.append('flash_drive', parseInt(this.flashdrive))
              var guide = []
              this.guide_name.forEach(val => {
                if (val !== '') {
                  guide.push({
                    name: val
                  })
                }
              })
              formData.append('guide_name', JSON.stringify(guide))

              var phg = []
              this.photograph_name.forEach(key => {
                if (key !== '') {
                  phg.push({
                    name: key
                  })
                }
              })
              formData.append('photograph_name', JSON.stringify(phg))

              formData.append('bill_amount', parseInt(this.TotalAmount))
              formData.append('cash_amount', parseInt(this.cash))
              formData.append('credit_amount', parseInt(this.credit_card))
              formData.append('folder_date', date)
              formData.append('folder_name', this.fd_name)
              formData.append('user_id', 0)
              formData.append('upload_status', 1)
              formData.append('bill_status', this.bill_status)
              formData.append('discription', this.discription)
              formData.append('is_new', 1)

              var header = {
                headers: {
                  'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: (progressEvent) => {
                  if (progressEvent.lengthComputable) {
                    this.updateProgressBarValue(this.bill_number, progressEvent)
                  }
                }
              }

              var billId = result.data[0].bill_id
              setTimeout(function () {
                this.isLoading = false
                this.$router.push({
                  name: 'Home'
                })
              }.bind(this), 5000)
              api.AXupload_cloud(
                this.url,
                formData,
                header,
                result => {
                  if (result.status === 1) {
                    var objE = {
                      bill_id: result.data[0].bill_id
                    }
                    var index = this.uploads.map(function (e) {
                      return e.id
                    }).indexOf(billId)
                    if (Emails.length > 0) {
                      api.AXsendemail(
                        this.url, objE,
                        result => {
                          swal(
                            'Good job!',
                            'Upload File Completed!',
                            'success'
                          )
                          this.uploads.splice(index, 1)
                          console.log(result)
                        },
                        error => {
                          alert(JSON.stringify(error))
                          this.uploads.splice(index, 1)
                        }
                      )
                    } else {
                      swal(
                        'Good job!',
                        'Upload File Completed!',
                        'success'
                      )
                      this.uploads.splice(index, 1)
                    }
                    // console.clear()
                  } else {
                    swal(
                      'Warnning!',
                      result.data,
                      'error'
                    )
                    var object = {
                      bills: [{
                        bill_key: result.data[0].bill_key
                      }]
                    }
                    api.AXdeletebill(this.url, object,
                      result => {
                        swal({
                          type: 'success',
                          title: 'Deleting',
                          text: 'Delete Bills successful!!'
                        })
                        this.uploads.splice(index, 1)
                      },
                      error => {
                        swal({
                          type: 'error',
                          title: 'Deleting Error',
                          text: JSON.stringify(error)
                        })
                        this.uploads.splice(index, 1)
                      }
                    )
                    console.log(result)
                  }
                },
                error => {
                  var index = this.uploads.indexOf(result.data[0].bill_id)
                  this.uploads.splice(index, 1)
                  alert(JSON.stringify(error))
                  var object = {
                    bills: [{
                      bill_key: result.data[0].bill_key
                    }]
                  }
                  console.log(error)
                  api.AXdeletebill(this.url, object,
                    result => {
                      swal({
                        type: 'success',
                        title: 'Deleting',
                        text: 'Delete Bills successful!!'
                      })
                      if (this.$route.name === 'Home') {
                        $('refeach').click()
                      }
                    },
                    error => {
                      swal({
                        type: 'error',
                        title: 'Deleting Error',
                        text: JSON.stringify(error)
                      })
                    }
                  )
                }
              )
            },
            error => {
              this.isLoading = false
              alert(JSON.stringify(error))
            }
          )
        }
      } else {
        this.check_bill()
      }
    }
  },
  mounted () {
    try {
      this.checkLogin()
    } catch (e) {
      // location.reload()
    }
    this.getmenu()
    this.$refs.billNumber.focus()
    // this.bill_status_options.push({
    //   value: 0,
    //   text: 'Cash'
    // }, {
    //   value: 1,
    //   text: 'Credit Card (' + this.config.per_creditcard + '%)'
    // }, {
    //   value: 2,
    //   text: 'Card + Credit Card (' + this.config.per_creditcard + '%)'
    // })
  }
}



// WEBPACK FOOTER //
// ./src/js/new_bill.js